import { Box, Typography } from "@mui/material";

interface AurClientProjectSectionHeaderProps {
  title: string;
  subheader?: string;
  className?: string;
  style?: React.CSSProperties;
  titleTestId?: string;
  subheaderTestId?: string;
}
export const AurClientProjectSectionHeader = ({
  title,
  subheader,
  className = '',
  style,
  titleTestId,
  subheaderTestId,
}: AurClientProjectSectionHeaderProps) => (
  <Box className={`form-content title-gap ${className}`} style={style}>
    <Typography
      data-testid={titleTestId}
      className="typo-text subhead3_size subhead3_size_cf"
    >
      {title}
    </Typography>
    {subheader && (
      <Typography
        data-testid={subheaderTestId}
        className="typo-text body3_size clientInfoSubheaderText"
      >
        {subheader}
      </Typography>
    )}
  </Box>
);